import httpClient from "@/plugins/httpClient";

export default {
  getProjects(id) {
    return httpClient.get(`compete/activities/${id}/projects`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/schoolApis/compete/projectsApis.js